import React, { useState } from 'react';
import { gnhAdminSummaryDashboardOverview } from './DrivingExemptionPageSelector';
import DrivingExemptionDashboard from './DrivingExemptionDashboard';
import { GNHView } from './DrivingExemptionView';
import DrivingExemptionPage from './DrivingExemptionPage';

const DrivingExemptionDashboardOverview = () => {

    return (
        <DrivingExemptionDashboard
            page={gnhAdminSummaryDashboardOverview}
            pageView={GNHView.Overview}
            />
    );
}

export default DrivingExemptionDashboardOverview;
